"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderMenuEndpoint = exports.menuEndpoint = void 0;
var routes_1 = require("~shared/utils/routes");
exports.menuEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/menus',
    method: 'post'
});
exports.reorderMenuEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/menus/reorder',
    method: 'post'
});
//# sourceMappingURL=menus.js.map